angular.module('access.Nodes')
    .factory('SignFile', [
        '$location',
        '$modal',
        '$rootScope',
        '$translate',
        'operationComplete',
        'RoutePaths',
        'template',
        ($location, $modal, $rootScope, $translate, operationComplete, RoutePaths, template) => {
            return (node) => {
                const $scope = $rootScope.$new(true);
                $scope.node = node;

                return _openModal({
                    action: 'init',
                    controller: 'SignFileInitModalController',
                    template: 'modals/actions/sign_file/_init',
                    windowTemplate: template('nodes/modal_loading')
                })
                    .then(({ pdf, pdfError, settings }) => {
                        $scope.pdf = pdf;
                        $scope.pdfError = pdfError;
                        $scope.settings = settings;

                        if ($scope.settings.sequential_sign) {
                            return _openModal({
                                action: 'notary',
                                controller: 'SignFileNotaryModalController',
                                template: 'modals/actions/sign_file/_notary',
                                windowTemplate: template('nodes/preview_window')
                            });
                        } else {
                            return _openModal({ action: 'signees', controller: 'SignFileSigneesModalController' });
                        }
                    })
                    .then((esignature) => {
                        operationComplete($translate.instant('esignature_sign_success_message'));
                        $location
                            .path(RoutePaths.SIGNED_FILES)
                            .search({
                                highlight_uuid: esignature.node_uuid,
                                highlight_esignature_uuid: esignature.uuid
                            });
                    });

                /**
                 * Open modal window with parameters:
                 * @param {object} params Hash-map of parameters
                 * @param {string} params.action Name of the action (modal body template will be determinate based on it)
                 * @param {string|Array|Function} params.controller Modal controller definition
                 * @param {string} [params.template=''] Specify modal's body template path
                 * @param {string} [params.windowTemplate=''] Modal's general template path
                 * @return {Promise} Will be resolved when modal closed, or rejected on dismiss
                 */
                function _openModal(params) {
                    const { action, controller, template = '', windowTemplate = '' } = params;

                    return $modal.open({
                        backdrop: 'static',
                        controller,
                        domOptions: {
                            modalAction: `sign_file/_${action}`,
                            modalNotifications: true,
                            modalType: 'confirm'
                        },
                        keyboard: false,
                        scope: $scope,
                        size: 'lg',
                        windowClass: `sign-file-${action}-dialog`,
                        ...(template ? { templateUrl: template } : {}),
                        ...(windowTemplate ? { windowTemplateUrl: windowTemplate } : {})
                    }).result;
                }
            };
        }
    ])
